import { render, staticRenderFns } from "./CourseTask.vue?vue&type=template&id=0635848c&scoped=true"
import script from "./CourseTask.vue?vue&type=script&lang=js"
export * from "./CourseTask.vue?vue&type=script&lang=js"
import style0 from "./CourseTask.vue?vue&type=style&index=0&id=0635848c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0635848c",
  null
  
)

export default component.exports